import {
  Box,
  Button,
  Dialog,
  DialogProps,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Theme,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import assest from "../../json/assest";
import { useAppSelector } from "../../hooks/useAppSelector";
// import assest from "@/json/assest";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  setDuplicates,
  setHasNote,
  setInquirerKey,
  setInquirerValue,
  setManagerId,
  setMonth,
  setPublished,
  setSubmitPlace,
  setUnreachableSubmitter,
  setYear,
} from "../../redux-toolkit/slices/contentBuyer.slice";
import {
  countryData,
  sampleDisplayList,
  sampleMonthsValueArray,
  sampleYearList,
  truncateString,
} from "../../lib/functions/utils.lib";
import styles from "../../styles/pages/buyerListModal.module.scss";
import countries from "countries-list";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

// const names = [
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
// ];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
// export type FilterModalProps = DialogProps & {
//     hideBottom?: boolean;
//     modalFields:
//         | {
//               has_note: string;
//               unreachable_submitter: string;
//               people_appearing: string;
//               person_who_filmed: string;
//               submit_other_website: string;
//               aggrement_with_another_company: string;
//           }
//         | any;
//     handleFilterParamChange: (event: ChangeEvent<HTMLInputElement>) => void;
//     resetFilterparams: () => void;
//     handleFilterSelect: () => void;
// };

const ContentBuyerWebsiteOnlyModal = (props) => {
  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );
  const [mockMonth, setMockMonth] = React.useState();
  const [mockInquirer, setMockInquirer] = React.useState();

  const dispatch = useAppDispatch();
  const { hideBottom, onClose, ...rest } = props;
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const {
    month,
    year,
    unreachable_submitter,
    submit_place,
    published,
    inquirer_value,
  } = useAppSelector((s) => s.contentBuyerSlice);

  const { inquirers } = useAppSelector((s) => s.appStateSlice);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  return (
    <Dialog className="filterModal" {...rest} onClose={handleClose}>
      <Box className="filterModalWrapper">
        <Box className="filterModalHeader">
          <h4>Filter</h4>
          <Button onClick={props?.handleClearFilterModal}>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className={`filterBodyBox ${styles.BuyerWebsiteModal}`}>
            <Box className={`filterBoxItem ${styles.markedBy}`}>
              <label>
                Marked By{" "}
                <img
                  onClick={() => {
                    dispatch(setInquirerKey(null));
                    dispatch(setInquirerValue(null));
                  }}
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                />
              </label>
              <Box className="filterSelect">
                <Select
                  labelId="user-label"
                  id="user-select"
                  displayEmpty
                  value={inquirer_value}
                  renderValue={() => {
                    // console.warn('selected', selected)
                    if (!inquirer_value) {
                      return <span>Inquirers</span>;
                    } else {
                      return <span>{mockInquirer.name}</span>;
                    }
                  }}
                  MenuProps={MenuProps}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={(e) => {
                    dispatch(setInquirerValue(e.target.value.id));
                    dispatch(setInquirerKey(e.target.value.role.name + "_id"));
                    setMockInquirer(e.target.value);
                    // console.warn("e.target.value", e.target.value);
                  }}
                >
                  {inquirers?.map((a, i) => (
                    <MenuItem key={i} value={a}>
                      {a.name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box className={`filterBoxItem ${styles.filmedIn}`}>
              <label>
                Filmed in{" "}
                <img
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                  onClick={() => {
                    dispatch(setYear(null));
                    dispatch(setMonth(null));
                  }}
                />
              </label>
              <Box className="filterSelect filterSelectSmall">
                <Select
                  labelId="month-label"
                  id="month-select"
                  displayEmpty
                  value={month}
                  renderValue={() => {
                    // console.warn('selected', selected)
                    if (!month) {
                      return <span>Month</span>;
                    } else {
                      return <span>{mockMonth.month}</span>;
                    }
                  }}
                  MenuProps={MenuProps}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={(e) => {
                    dispatch(setMonth(e.target.value.value));
                    setMockMonth(e.target.value);
                    // console.warn("e.target.value", e.target.value);
                  }}
                >
                  {sampleMonthsValueArray.map((m, i) => (
                    <MenuItem key={i} value={m}>
                      {m.month}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  labelId="year-label"
                  id="year-select"
                  displayEmpty
                  value={year}
                  renderValue={(selected) => {
                    // console.warn('selected', selected)
                    if (!selected) {
                      return <span>Year</span>;
                    } else {
                      return <span>{selected}</span>;
                    }
                  }}
                  MenuProps={MenuProps}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={(e) => {
                    dispatch(setYear(e.target.value));
                    console.warn("e.target.value", e.target.value);
                  }}
                >
                  {sampleYearList.map((y, i) => (
                    <MenuItem key={i} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box className={`filterBoxItem ${styles.filmingLocation}`}>
              <label>
                Filming Location{" "}
                <img
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                  onClick={() => dispatch(setSubmitPlace(null))}
                />
              </label>
              <Box className="filterSelect">
                <Select
                  labelId="location-label"
                  id="location-select"
                  displayEmpty
                  value={submit_place}
                  renderValue={(selected) => {
                    // console.warn('selected', selected)
                    if (!selected) {
                      return <span>Location</span>;
                    } else {
                      return <span>{selected}</span>;
                    }
                  }}
                  MenuProps={MenuProps}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={(e) => {
                    dispatch(setSubmitPlace(e.target.value));
                    console.warn("e.target.value", e.target.value);
                  }}
                >
                  {countryNames.map((p, i) => (
                    <MenuItem key={i} value={p}>
                      {truncateString(p, 20)}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box className={`filterBoxItem ${styles.display}`}>
              <label>
                Display{" "}
                <img
                  onClick={() => dispatch(setPublished(null))}
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                />
              </label>
              <Box className="filterSelect">
                <Select
                  labelId="user-label"
                  id="user-select"
                  displayEmpty
                  value={published}
                  renderValue={() => {
                    // console.warn('selected', selected)
                    if (!published) {
                      return <span>All videos (default)</span>;
                    } else {
                      return <span>{published}</span>;
                    }
                  }}
                  MenuProps={MenuProps}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={(e) => {
                    dispatch(setPublished("yes"));
                  }}
                >
                  {sampleDisplayList?.map((a, i) => (
                    <MenuItem key={i} value={a}>
                      {a}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            <Box className={`filterBoxItem ${styles.unreachableSubmitter}`}>
              <label>
                Unreachable Owner?{" "}
                <img
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                  onClick={() => dispatch(setUnreachableSubmitter(null))}
                />
              </label>
              {/* <Box className="filterRadio">
                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio />} label="No" />
                  </Box> */}
              <Box className="filterRadio">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={unreachable_submitter}
                    name="unreachable_submitter"
                    onChange={(e) =>
                      dispatch(setUnreachableSubmitter(e.target.value))
                    }
                  >
                    <Box className="filterFromControl">
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button className="activeButton" onClick={props?.filterRefetch}>
              Filter now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ContentBuyerWebsiteOnlyModal;
